/* Video tutorial widget — gedrag voor snippets/video-tutorial.liquid.
   Werkt met meerdere widgets op één pagina; alle state hangt aan de root. */
(function () {
  'use strict';

  var EMBED = 'https://www.youtube.com/embed/';

  function embedUrl(id, autoplay) {
    if (!id) return '';
    // Al een volledige URL (legacy playlist-data): laat hem staan.
    var base = id.indexOf('//') === -1 ? EMBED + encodeURIComponent(id) + '?rel=0' : id;
    if (!autoplay) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
  }

  /* Thumbnails verwijzen naar een bestandsnaam uit Content → Files van déze shop.
     Staat dat bestand er (nog) niet, dan valt de afbeelding terug op
     data-vt-fallback: de YouTube-thumbnail, of de productfoto bij een groepsknop.
     Zo levert een ontbrekend bestand nooit een kapot plaatje op. */
  function applyFallback(img) {
    var fallback = img.getAttribute('data-vt-fallback');
    img.removeAttribute('data-vt-fallback');
    if (fallback) img.src = fallback;
  }

  // 'error' bubbelt niet, dus meeluisteren in de capture-fase.
  document.addEventListener('error', function (event) {
    var el = event.target;
    if (el && el.tagName === 'IMG' && el.hasAttribute('data-vt-fallback')) applyFallback(el);
  }, true);

  function sweepBrokenImages(root) {
    root.querySelectorAll('img[data-vt-fallback]').forEach(function (img) {
      // Al gefaald voordat de listener stond.
      if (img.complete && img.naturalWidth === 0) applyFallback(img);
    });
  }

  function init(root) {
    if (root.dataset.vtReady === 'true') return;
    root.dataset.vtReady = 'true';

    sweepBrokenImages(root);

    var frame = root.querySelector('[data-vt-frame]');
    if (!frame) return;

    function play(row, autoplay) {
      if (!row) return;

      root.querySelectorAll('[data-vt-video]').forEach(function (r) {
        r.classList.remove('is-active');
      });
      row.classList.add('is-active');

      var url = embedUrl(row.getAttribute('data-video-id'), autoplay);
      if (!url) return;

      // De aangeklikte regel volledig in beeld houden binnen de scrollende lijst.
      if (row.scrollIntoView) {
        row.scrollIntoView({ block: 'nearest' });
      }

      frame.src = url;
      frame.setAttribute('title', row.getAttribute('data-video-title') || '');
    }

    root.addEventListener('click', function (event) {
      var row = event.target.closest('[data-vt-video]');
      if (row && root.contains(row) && !row.classList.contains('is-active')) {
        play(row, true);
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify-customizer: opnieuw binden als een sectie herladen wordt.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
